import { useContext, useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import { Typography, Button, Spinner } from "@material-tailwind/react";
import { add_ratio_data, update_ratio } from '../../Controller/actions';
import { NewContext } from '../../Context/NewContext';
import { FileInput } from '../FileInput/FileInput'
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Switch from '../Switch/Switch';
import CreatableSelect from 'react-select/creatable';

export const RatioModel = () => {
    const { isModalLoading, setFormData, setDeleteUpdateTag, deleteUpdateYes, handleSwitch, setIsModalLoading, handleClose, formData, open, addEditDeleteTag, handleChange, setImgObj, imgObj } = useContext(NewContext);
    const [selectedRatioOption, setSelectedRatioOption] = useState([]);

    useEffect(() => {
        if (addEditDeleteTag === `add`) setFormData({ ...formData, isActive: true })
    }, [addEditDeleteTag, deleteUpdateYes]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        let createUpdateAiArtStyle;
        setIsModalLoading(true);

        const obj = {
            ...formData,
            aspectRatioName: formData?.aspectRatioName,
            aspectRatioValue: selectedRatioOption.value,
            aspectRatioPreview: formData?.aspectRatioPreview,
            isActive: formData?.isActive ? true : false,
            isPremium: formData?.isPremium ? true : false,
        }

        if (addEditDeleteTag === `update`) {
            createUpdateAiArtStyle = await update_ratio(obj, formData?._id)
        } else {
            createUpdateAiArtStyle = await add_ratio_data(obj)
        }

        setIsModalLoading(false);
        if (createUpdateAiArtStyle) {
            const { message, status } = createUpdateAiArtStyle;
            if (status) {
                toast.success(message);
                handleClose();
                setSelectedRatioOption(null);
                setDeleteUpdateTag(deleteUpdateYes);
            } else {
                toast.error(message);
            };
        }
    }
    const options = [
        { value: 'SDXL - 1:1 square 1024x1024', label: 'SDXL - 1:1 square 1024x1024' },
        { value: 'SDXL - 3:4 portrait 896x1152', label: 'SDXL - 3:4 portrait 896x1152' },
        { value: 'SDXL - 5:8 portrait 832x1216', label: 'SDXL - 5:8 portrait 832x1216' },
        { value: 'SDXL - 9:16 portrait 768x1344', label: 'SDXL - 9:16 portrait 768x1344' },
        { value: 'SDXL - 9:21 portrait 640x1536', label: 'SDXL - 9:21 portrait 640x1536' },
        { value: 'SDXL - 4:3 landscape 1152x896', label: 'SDXL - 4:3 landscape 1152x896' },
        { value: 'SDXL - 3:2 landscape 1216x832', label: 'SDXL - 3:2 landscape 1216x832' },
        { value: 'SDXL - 16:9 landscape 1344x768', label: 'SDXL - 16:9 landscape 1344x768' },
        { value: 'SDXL - 21:9 landscape 1536x640', label: 'SDXL - 21:9 landscape 1536x640' },

    ];
    useEffect(() => {
        if (formData && formData.aspectRatioValue) {
            setSelectedRatioOption({ value: formData.aspectRatioValue, label: formData.aspectRatioValue });
        }
    }, [addEditDeleteTag]);

    return (
        <>
            <Dialog
                open={open}
                onClose={() => { handleClose(); setSelectedRatioOption([]); }}
                aria-labelledby="responsive-dialog-title"
                sx={{
                    "& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                            width: "100%",
                            maxWidth: "490px",
                            height: "100%",
                            maxHeight: "520px",
                            borderRadius: "12px"
                        },
                    },
                }}
            >
                <DialogTitle id="responsive-dialog-title" className='p-0 mb-[30px] text-[#1E1627]'>
                    {
                        addEditDeleteTag === 'view' ? 'Details View' : addEditDeleteTag === 'update' ? `Edit Ratio ` : `Add Ratio `
                    }

                </DialogTitle>

                <DialogContent>
                    <div>
                        {
                            <form onSubmit={handleSubmit}>
                                <div className='lg:col-span-2 '>
                                    <Typography className="text-lg text-[#1E1627] font-medium">Ratio Preview  <span className='text-red-800'>*</span></Typography>
                                    <div className='w-auto mx-auto'>
                                        <FileInput name={`aspectRatioPreview`} imgClass={`h-full`} previewFields={'aspectRatioPreview'} accept={'image/*'} acceptedExtensions={/\.(jpg|png|webp|svg)$/} required validation={false} />
                                    </div>
                                </div>
                                <div className="grid grid-cols-6 lg:grid-cols-6 gap-5 add-edit-form mt-4">
                                    <div className="col-span-6 sm:col-span-6">
                                        <div className='mt-2'>
                                            <label htmlFor="aspectRatioValue" name='aspectRatioValue' className="block text-sm font-medium leading-6 text-gray-900">Ratio Value:<span className='text-red-800'>*</span></label>
                                            <CreatableSelect
                                                required
                                                options={options}
                                                value={selectedRatioOption}
                                                onChange={(selectedRatioOption) => {
                                                    setSelectedRatioOption(selectedRatioOption);
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-span-6 sm:col-span-6 ">
                                        <label htmlFor="aspectRatioName" className="block text-sm font-medium leading-6 text-gray-900"> Ratio Name <span className='text-red-800'>*</span></label>
                                        <div className="mt-2">
                                            <input
                                                id='aspectRatioName'
                                                className=' w-full border px-3 py-2 rounded-[7px] text-sm border-blue-gray-200 focus:border-blue-500'
                                                placeholder='Enter Ratio Name'
                                                name='aspectRatioName'
                                                onChange={handleChange}
                                                minLength={1}
                                                maxLength={40}
                                                type='String'
                                                min={1}
                                                value={formData?.aspectRatioName || ''}
                                                autoComplete='off'
                                                required
                                            />
                                        </div>
                                    </div>


                                    <div className="col-span-3 sm:col-span-3 ">
                                        <label htmlFor="isActive" className="block text-sm font-medium leading-6 text-gray-900">isActive:</label>
                                        <div className="mt-1.5">
                                            <Switch color='green' id='isActive' name='isActive' onChange={handleSwitch} checked={formData?.isActive} />
                                        </div>
                                    </div>

                                    <div className="col-span-3 sm:col-span-3 ">
                                        <label htmlFor="isPremium" className="block text-sm font-medium leading-6 text-gray-900">isPremium:</label>
                                        <div className="mt-1.5">
                                            <Switch color='green' id='isPremium' name='isPremium' onChange={handleSwitch} checked={formData?.isPremium} />
                                        </div>
                                    </div>

                                </div>
                                <div className='flex justify-end mt-10'>
                                    <Button
                                        onClick={() => { handleClose(); setSelectedRatioOption([]); setFormData({}) }}
                                        className="mr-2.5 px-5 py-2.5 bg-white shadow-none text-[#1E3354] font-medium border border-[#75869F] hover:shadow-none capitalize text-base"
                                    >
                                        <span>Cancel</span>
                                    </Button>
                                    <Button
                                        disabled={isModalLoading}
                                        className="flex items-center mr-1 px-5 py-2.5 bg-[#0047FF] shadow-none text-white font-medium border border-[#0047FF] hover:shadow-none capitalize text-base"
                                        type='submit'
                                    >
                                        {isModalLoading && <Spinner className="h-4 w-4" />}
                                        <span className={isModalLoading ? 'ml-4' : ''}>{addEditDeleteTag === `update` ? `Update` : `Add`}</span>
                                    </Button>
                                </div>
                            </form>
                        }
                    </div>
                </DialogContent>
            </Dialog>
        </>
    )
}

export default RatioModel
